import * as angular from "angular";
import {IController} from "angular";

export class ServiceTaskPodsComponent implements IController {
  service: any;
  onClick: Function;

  public podsCount: number;

  constructor() {
  }

  $onInit() {
    this.initData();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.service && !changes.service.isFirstChange()) {
      this.initData();
    }
  }


  private initData() {
    this.podsCount = 0;
    this.service.taskList.forEach((t) => {
      if (!!t.taskSpec.identifications) {
        Object.entries(t.taskSpec?.identifications).forEach(([key, value], index) => {
          if (key.includes('BlobName')) {
            this.podsCount += 1;
          }
        });
      }
    })
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceTaskPods', {
    bindings: {
      service: '<'
    },
    template: require('./service-task-pods.html').default,
    controller: ServiceTaskPodsComponent
  });
